module.exports = __webpack_public_path__ + "img/IAR5.1.60cc7fee.png";